/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { Button as Btn } from 'reactstrap'

export type BaseBgColor = 'primary' | 'secondary' | 'danger' | 'transparent' | 'light'

interface ButtonOption {
  isDisable?: boolean
  id?: string
  onClick?: (e: any) => void
  optionalClass?: string
  basBgColor?: BaseBgColor
  customBgColor?: string
  textColor?: string
  children?: React.ReactNode
}

const Button: React.FC<ButtonOption> = ({
  isDisable,
  onClick,
  optionalClass = '',
  basBgColor = 'secondary',
  textColor = 'black',
  customBgColor,
  children,
  id
}) => {
  return (
    <>
      <Btn
        id={id}
        disabled={isDisable}
        onClick={onClick}
        className={optionalClass}
        color={basBgColor}
        style={{ color: textColor, backgroundColor: customBgColor }}
      >
        {children}
      </Btn>
    </>
  )
}

export default Button
